export const projects = [
  {
    id: 'oldschooltools',
    name: 'Old School Tools',
    developers: ['James Cerniglia'],
    skillsUsed: ['Javascript', 'TypeScript'],
    clicked: false,
    liveBool: true,
    sourceBool: true,
    description:
      'Node package made for developers to easily access organized data from Old School RuneScape.',
    likes: 0,
    codeUrl: 'https://www.npmjs.com/package/osrs-tools',
    liveUrl: 'https://osrs-sim.vercel.app/home',
    referenceUrl: '/osrs-tools-demo',
    longDescription: '',
    imgUrl: './assets/projects/osrs-sailing.png',
  },

  {
    id: 'Discord Bot',
    name: 'Discord Bot',
    developers: ['James Cerniglia'],
    skillsUsed: ['Javascript', 'Discord.py'],
    clicked: false,
    liveBool: false,
    sourceBool: true,
    description:
      'A Discord bot that provides various utilities and fun commands for server members.',
    likes: 0,
    codeUrl: 'https://github.com/jamescer/squeeze-discord-bot',
    liveUrl:
      'https://discord.com/oauth2/authorize?client_id=565722545580539914',
    longDescription: '',
    imgUrl: './assets/projects/discord-bot.png',
  },

  {
    id: 'Aglorithm App',
    name: 'Aglorithm App',
    description:
      'An application that helps users learn and visualize algorithms through interactive examples and visualizations.',
    developers: ['James Cerniglia'],
    skillsUsed: ['Javascript', 'React'],
    clicked: false,
    liveBool: true,
    sourceBool: true,
    likes: 0,
    codeUrl: 'https://github.com/jamescer/algo-app',
    liveUrl: 'https://algo-app-zeta.vercel.app/',
    longDescription: '',
    imgUrl: './assets/projects/hydra2.png',
  },

  {
    id: 'RTC App',
    name: 'Rolling Thunder Cycles Legacy',
    description:
      'A website for a retired motorcycle reapir shop that showcases their memories and services.',
    developers: ['James Cerniglia'],
    skillsUsed: ['Javascript', 'Typescript', 'React'],
    clicked: false,
    liveBool: true,
    sourceBool: true,
    likes: 0,
    codeUrl: 'https://github.com/jamescer/rtc-1',
    liveUrl: 'https://www.rollingthundercycles.com/',
    longDescription: '',
    imgUrl: './assets/projects/rtc.png',
  },
];
